
import axios from 'axios';

const isOnline = /market\.baidu\.com/.test(window.location.hostname);

let link = isOnline ? {
    require: 'https://gwgp-tkkaggvy9hn.i.bdcloudapi.com'
} : {
    require: 'https://gwgp-g9dwxmpdnkt.i.bdcloudapi.com'
};

export default {
    getBlaPrice(param) {
        return axios.post('/api/bla/products/list', param);
    },
    getVerifyCode(param) {
        return axios.post(`${link.require}/api/tms/reservation/verify`, param);
    },
    getConsultSubmit(param) {
        return axios.post(`${link.require}/api/tms/reservation/save`, param);
    },
    queryStaticData() {
        return axios.get('/api/crs/static/data');
    },
    queryBkpPrice(params) {
        return axios.get('/api/crs/price/bkp', {
            params
        });
    },
    // 获取代理记账服务的验证码
    getBkpVerifyCode(params) {
        return axios.post('/api/crs/verification/sms', params);
    },
    // 提交代理记账的需求
    submitBkpDemand(params) {
        return axios.post(params.hasLogin ? '/api/crs/demand' : '/api/crs/demand/anonymous', params);
    }
};